import React from 'react'
import Loadable from 'Components/LoadableToImported'

const loading = () => <div />


export { default as Collapsible } from './Collapsible'
export { default as CollapsibleExtraDescription } from './CollapsibleExtraDescription'
export { default as BuildingAmenities } from './BuildingAmenities'


export const AgentFavBar = Loadable({
  loader: () => import(/* webpackChunkName: "AgentFavBar" */ './AgentFavBar'),
  loading,
  chunkName: 'AgentFavBar',
})

export const Rooms = Loadable({
  loader: () => import(/* webpackChunkName: "Rooms" */ './Rooms'),
  loading,
  chunkName: 'Rooms',
})

export const BreadCrumbs = Loadable({
  loader: () => import(/* webpackChunkName: "BreadCrumbs" */ './BreadCrumbs'),
  loading,
  chunkName: 'BreadCrumbs',
})


export const TileSlider = Loadable({
  loader: () => import(/* webpackChunkName: "TileSlider" */ './TileSlider'),
  loading,
  chunkName: 'TileSlider',
})


export const ProfileCard = Loadable({
  loader: () => import(/* webpackChunkName: "ProfileCard" */ './ProfileCard'),
  loading,
  chunkName: 'ProfileCard',
})

export const MortgageCalculator = Loadable({
  loader: () => import(/* webpackChunkName: "MortgageCalculator" */ './Calculator/MortgageCalculatorApiContainer'),
  loading,
  chunkName: 'MortgageCalculator',
})

export const BuyVsRentCalculator = Loadable({
  loader: () => import(/* webpackChunkName: "BuyVsRentCalculator" */ './Calculator/BuyVsRentCalculatorApiContainer'),
  loading,
  chunkName: 'BuyVsRentCalculator',
})

export const AnalyticsWithSpinner = Loadable({
  loader: () => import(/* webpackChunkName: "AnalyticsWithSpinner" */ './AnalyticsWithSpinner'),
  loading,
  chunkName: 'AnalyticsWithSpinner',
})

export const NearbyMapWithPreviews = Loadable({
  loader: () =>
    import(/* webpackChunkName: "NearbyMapWithPreviews" */ './NearbyMapWithPreviews/NearbyMapWithPreviewsApiContainer'),
  loading,
  chunkName: 'NearbyMapWithPreviews',
})

export const ToolTips = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ToolTips" */ './ToolTips'),
  loading,
  chunkName: 'ToolTips',
})


export const MapListingPopup = Loadable({
  loader: () =>
    import(/* wcomment: "MapListingPopup" */ './MapListingPopup'),
  loading,
  chunkName: 'MapListingPopup',
})

export const MapBuildingPopup = Loadable({
  loader: () =>
    import(/* wcomment: "MapBuildingPopup" */ './MapBuildingPopup'),
  loading,
  chunkName: 'MapBuildingPopup',
})

